/**
 * Hands a downloaded file to the browser to save. The file is never opened inside the app: the
 * CSP forbids framing blob URLs, and a PDF shown in our origin could run its own scripts.
 */
export function saveFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const link = window.document.createElement("a");
    link.href = url;
    // Slashes (as in contract numbers) aren't allowed in file names.
    link.download = fileName.replaceAll("/", "-");
    link.rel = "noopener";
    window.document.body.append(link);
    link.click();
    link.remove();
  } finally {
    // Give the browser a moment to start the download before the URL goes away.
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  }
}
